// Libraries
var React = require("react");

// Components
var GenericRichText = require('../RichText/GenericRichText');

// Style
require("./Intro.scss");

class IntroModule extends React.Component {

  createMarkup() {
    return {__html: this.props.data.text};
  }

  render() {
    const additionalIntroClass = this.props.data.isOneHotspur ? ' c-intro--one-hotspur c-section--one-hotspur' : this.props.data.isPremium ? ' c-intro--premium' : this.props.data.isOneHotspurPass ? ' c-intro--one-hotspur-pass' : '';

    return (
      <div className={`c-section c-section--gutter c-section--always-padded c-intro ${
        additionalIntroClass
      }`} id={this.props.data.id}>
        <div className="c-section__inner">
          <div className="c-intro__inner">
            <div className="c-intro__title-container">
              <h2 className="c-intro__title">{this.props.data.title}</h2>
            </div>
            <div className="c-intro__content">
              <GenericRichText content={this.props.data.text} isPremium={this.props.data.isPremium} largeText={true} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = IntroModule;



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js